import React, { Component } from "react";
import axios from "axios";

import "../App.css";

import { Button, ButtonGroup, Input } from "@chakra-ui/react";
import { IoIosArrowDropright } from "react-icons/io";

import Navbar from "../Componets/TopNavbar";
import List from "../Componets/List";
import Offcanvas from "../Componets/offCanvas/offcanvas";

import {
  getListDestails,
  createList,
  deleteList,
  getAllCards,
} from "../Api/apis";

export default class listView extends Component {
  state = {
    list: [],
    isAddclicked: false,
    listName: "",
    show: false,
  };

  renderInputField = () => {
    return (
      <div
        style={{
          display: "flex",
          marginTop: "20px",
          marginLeft: "20px",
          marginRight: "20px",
        }}
      >
        <Input
          placeholder="input list name"
          variant="filled"
          focusBorderColor="lime"
          color="white"
          size="md"
          style={{ height: "45px" }}
          onChange={(event) => this.setState({ listName: event.target.value })}
        />
        <Button
          colorScheme="black"
          color="black"
          backgroundColor="white"
          onClick={() =>
            this.addList(this.state.listName, this.props.match.params.id)
          }
          style={{ marginLeft: "5px" }}
        >
          save
        </Button>
      </div>
    );
  };

  getAllListDestails = (boardID) => {
    const allLists = getListDestails(boardID);

    allLists.then((lists) => {
      this.setState({ list: lists });
    });
  };

  createClicked = () => {
    this.setState({ isAddclicked: true });
  };

  addList = (name, id) => {
    const list = createList(name, id);

    list.then((list) => {
      this.setState({ list: [...this.state.list, list] });
    });

    this.setState({ isAddclicked: false });
  };

  removeList = (listId) => {
    deleteList(listId);
    const updatedList = this.state.list.filter((item) => item.id !== listId);
    this.setState({ list: updatedList });
  };

  componentDidMount() {
    this.getAllListDestails(this.props.match.params.id);
  }

  render() {
    console.log(this.state.list);

    let stateData = this.props.location.state;
    var backgroundImage = stateData["backgroundImg"];

    const handleClose = () => this.setState({ show: false });
    const handleShow = () => this.setState({ show: true });

    return (
      <div
        style={{
          backgroundImage: `url("${backgroundImage}")`,
          backgroundRepeat: "repeat",
          width: "100%",
          height: "100vh",

          color: "blue",
          backgroundSize: "contain",
          backgroundColor: "#0079bf",
        }}
      >
        <Navbar />
        <div
          style={{
            width: "20px",
            height: "100vh",
            backgroundColor: "#298fc9",
            position: "fixed",
          }}
        >
          <button onClick={handleShow} style={{ color: "green" }}>
            <IoIosArrowDropright style={{ color: "white", fontSize: "24px" }} />
          </button>
        </div>

        <Offcanvas show={this.state.show} close={handleClose} />
        <div style={{ display: "flex" }}>
          <div style={{ display: "flex" }}>
            {this.state.list.map((item) => {
              return (
                <List
                  data={item}
                  displayCard={getAllCards}
                  deleteList={this.removeList}
                />
              );
            })}
          </div>

          {this.state.isAddclicked && this.renderInputField()}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "40px",
              marginRight: "20px",
            }}
          >
            <ButtonGroup size="md" isAttached variant="filled">
              <Button
                mr="-px"
                onClick={this.createClicked}
                style={{
                  marginTop: "-40px",
                  backgroundColor: "#346ac6",
                  color: "white",
                  fontSize: "14",
                  fontWeight: "normal",
                }}
                className="button-4"
              >
                + add another list
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </div>
    );
  }
}
